
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-case/[path]",
      function () {
        return require("private-next-pages/use-case/[path]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-case/[path]"])
      });
    }
  